import React from "react";

export function FairTeaserContent({
    formatedStartDate,
    formatedEndDate,
    fairLocation
}) {
    return (
        <p>
            {formatedStartDate} - {formatedEndDate}
            <br />
            {fairLocation}
        </p>
    );
}
